import { useAppDispatch, useAppSelector } from "../../app/hooks";
import PEPText from "./PEPText";
import { closeModal } from "../../reducers/modalReducer";
import { Modal } from "@allaria-tech/matter/Modal";
import useMobileLayout from "../../hooks/useMobileLayout";

import styles from "./PEPModal.module.scss";

const PEPModal = () => {
  const { wrapper, modal } = styles;

  const dispatch = useAppDispatch();
  const { modalName } = useAppSelector((state) => state.modal);
  const { isCryptoAppModal } = useMobileLayout();

  const handleClose = () => dispatch(closeModal());

  return (
    <Modal
      isOpen={modalName === "modal-PEP"}
      onClose={handleClose}
      title="¿Qué es ser PEP?"
      primaryAction={{ text: "Cerrar", onClick: handleClose }}
      footerAlignment={isCryptoAppModal ? "center" : "right"}
      disableMobileLayout={isCryptoAppModal}
    >
      <div className={wrapper}>
        <div className={modal}>
          <div>
            <p className="mb-1">Resoluciones 35/2023 y 192/2024 de UIF</p>
            <div className="d-flex flex-row justify-content-between">
              <p className="mb-1 text-gray">RESOL-2023-35-APN-UIF#MEC</p>
              <p className="mb-1 text-gray">Fecha de publicación 02/03/2023</p>
            </div>
            <hr className="my-3" />
          </div>
          <PEPText />
        </div>
      </div>
    </Modal>
  );
};

export default PEPModal;
